export const countEstimateYieldMonth = (
  monthPrice?: number | null,
  rentalDays?: number | null,
) => {
  let estimatedYieldMonth = null;
  if (monthPrice && rentalDays) {
    estimatedYieldMonth = (monthPrice / 30) * rentalDays;
  }
  return estimatedYieldMonth;
};
